<template>
  <div class="leftnav w-hidden-small w-hidden-tiny">
    <a href="/" class="brandlink w-inline-block">
      <div class="div-block-26">
        <div class="div-block-51"><img src="../../static/images/cabinet-manager.png" width="28" class="image-3">
          <div class="text-block-14">Cabinet Manager</div>
        </div>
      </div>
    </a>
    <div class="functionlinks">
      <a :href="'/#/dashboard?project='+ project.id" class="link-block-4 drawing w-inline-block"> <!-- Replace original to drawing to underline drawing tab -->
        <div class="div-block-28" :style="currentPage === 'dashboard' ? 'color: #4fb3be;':'color: rgba(255, 255, 255, 0.7);'"><i class="material-icons image-4" width="26">image_aspect_ratio</i>
          <div>Design Drawing</div>
        </div>
      </a>
      <a :href="'/#/items?project=' + project.id" class="link-block-4 original w-inline-block">
        <div class="div-block-28" :style="currentPage === 'items' ? 'color: #4fb3be;':'color: rgba(255, 255, 255, 0.7);'"><i class="material-icons image-4" width="26">ballot</i>
          <div>Items</div>
        </div>
      </a>
      <a :href="'/#/colors?project=' + project.id" class="link-block-4 original w-inline-block">
        <div class="div-block-28" :style="currentPage === 'colors' ? 'color: #4fb3be;':'color: rgba(255, 255, 255, 0.7);'"><i class="material-icons image-4" width="26">style</i>
          <div>Colors</div>
        </div>
      </a>
      <a :href="'/#/statistics?project='+ project.id" class="link-block-4 original w-inline-block">
        <div class="div-block-28" :style="currentPage === 'statistics' ? 'color: #4fb3be;':'color: rgba(255, 255, 255, 0.7);'"><i class="material-icons image-4" width="26">get_app</i>
          <div>Export Tool</div>
        </div>
      </a>
      <a :href="'/#/settings?project=' + project.id" class="link-block-4 original w-inline-block">
        <div class="div-block-28" :style="currentPage === 'settings' ? 'color: #4fb3be;':'color: rgba(255, 255, 255, 0.7);'"><i class="material-icons image-4" width="26">settings</i>
          <div>Project Setting</div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavSideBar',
  props: ['currentPage', 'project']
}
</script>

<style scoped>
.current {
  color: #4fb3be;
}
</style>



// WEBPACK FOOTER //
// src/components/NavSideBar.vue